export const NOTIFICATIONS_KEY = "NOTIFICATIONS";
export const NOTIFICATION_KEY = "NOTIFICATION";
export const NOTIFICATION_RECIPIENTS_KEY = "NOTIFICATION_RECIPIENTS";
export const SELECTS_KEY = "SELECTS";